'use client';

import { Dialog } from '@skin-seoul/design-system';
import { SkinSocietyBenefits } from '../SkinSocietyBenefits';
interface SkinSocietyBenefitsModalProps {
  isOpen: boolean;
  onClose: () => void;
  showBottomNav?: boolean;
  showSigninComment?: boolean;
}
export const SkinSocietyBenefitsModal = ({
  isOpen,
  onClose,
  showBottomNav = true,
  showSigninComment = false
}: SkinSocietyBenefitsModalProps) => {
  const bottomMargin = showBottomNav ? '63px' : '0px';
  const maxContentHeight = showSigninComment ? '95dvh' : '80dvh';
  const maxBodyHeight = showBottomNav ? `calc(${maxContentHeight} - 63px)` : maxContentHeight;
  return <Dialog.Root open={isOpen} onOpenChange={e => !e.open && onClose()} data-sentry-element="Dialog.Root" data-sentry-component="SkinSocietyBenefitsModal" data-sentry-source-file="SkinSocietyBenefitsModal.tsx">
      <Dialog.Backdrop backgroundColor="rgba(0, 0, 0, 0.5)" backdropFilter="blur(2px)" zIndex={1650} data-sentry-element="Dialog.Backdrop" data-sentry-source-file="SkinSocietyBenefitsModal.tsx" />
      <Dialog.Positioner alignItems="flex-end" zIndex={1650} data-sentry-element="Dialog.Positioner" data-sentry-source-file="SkinSocietyBenefitsModal.tsx">
        <Dialog.Content width="100%" maxWidth="100vw" maxHeight={maxContentHeight} bg="transparent" borderTopRadius="20px" borderBottomRadius="0" mx={0} my={0} mb={bottomMargin} overflow="hidden" data-sentry-element="Dialog.Content" data-sentry-source-file="SkinSocietyBenefitsModal.tsx">
          <Dialog.Body p={4} pt={33} position="relative" zIndex={1} overflow="auto" bg="primary.900" maxHeight={maxBodyHeight} data-sentry-element="Dialog.Body" data-sentry-source-file="SkinSocietyBenefitsModal.tsx">
            <SkinSocietyBenefits showSigninComment={showSigninComment} data-sentry-element="SkinSocietyBenefits" data-sentry-source-file="SkinSocietyBenefitsModal.tsx" />
          </Dialog.Body>
        </Dialog.Content>
      </Dialog.Positioner>
    </Dialog.Root>;
};